import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=unknown, false=anon, object=auth
  const [token, setToken] = useState(() => localStorage.getItem("sm_admin_token") || "");

  const fetchMe = useCallback(async (tk) => {
    try {
      const res = await api.get("/auth/me", { headers: { Authorization: `Bearer ${tk}` } });
      setUser(res.data);
      api.defaults.headers.common["Authorization"] = `Bearer ${tk}`;
    } catch {
      localStorage.removeItem("sm_admin_token");
      delete api.defaults.headers.common["Authorization"];
      setUser(false);
      setToken("");
    }
  }, []);

  useEffect(() => {
    if (token) fetchMe(token);
    else setUser(false);
  }, [token, fetchMe]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    const tk = res.data.access_token;
    localStorage.setItem("sm_admin_token", tk);
    api.defaults.headers.common["Authorization"] = `Bearer ${tk}`;
    setToken(tk);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("sm_admin_token");
    delete api.defaults.headers.common["Authorization"];
    setToken("");
    setUser(false);
  };

  return (
    <AdminAuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
